import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { TopicEffects } from './topic.effects';
import { reducer } from './topic.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('topic', reducer),
    EffectsModule.forFeature([TopicEffects]),
  ],
  providers: [TopicEffects],
})
export class TopicStoreModule {}
